function apply(moduleConfig, config) {
	const {forceDisable, timeout, ...gdprConfig} = config.gdpr ?? {};

	if (!forceDisable) {
		moduleConfig.consentManagement = {
			'gdpr': {
				'cmpApi': 'iab',
				'defaultGdprScope': true,
				'timeout': typeof timeout === 'undefined' ? 8000 : timeout,
				...gdprConfig
			}
		};
	}
}

export default {
	apply
};
